import _ from 'lodash'

const fn = {
  updateValue(val) {
    const arrays = val.split(' ')
    // console.log(arrays)
    return {
      sVal: arrays[0],
      mVal: arrays[1],
      hVal: arrays[2],
      dVal: arrays[3],
      monthVal: arrays[4],
      weekVal: arrays[5],
      yearVal: arrays[6],
    }
  },
  // cron秒/分/小时转中文
  timeForDesc(type, data) {
    if (data.indexOf('-') > -1) {
      const sArr = data.split('-')
      if (sArr.length && sArr[0] === sArr[1]) {
        return `第${sArr[0]}${type}`
      }
      return `第${sArr[0]}${type}至第${sArr[1]}${type}`
    }
    if (data.indexOf('/') > -1) {
      const sArr = data.split('/')
      return `从第${sArr[0]}${type}开始每${sArr[1]}${type}`
    }
    if (!_.isNaN(Number(data)) || data.indexOf(',') > -1) {
      return `${data}${type}`
    }
    return type
  },
  // cron天转中文
  dayForDesc(data) {
    if (data.indexOf('-') > -1) {
      const hArr = data.split('-')
      if (hArr.length && hArr[0] === hArr[1]) {
        return `第${hArr[0]}天`
      }
      return `第${hArr[0]}天至第${hArr[1]}天`
    }
    if (data.indexOf('/') > -1) {
      const hArr = data.split('/')
      return `从第${hArr[0]}天开始每${hArr[1]}天`
    }
    if (data.indexOf('W') > -1) {
      return `每月${hArr[0]}号最近的工作日`
    }
    if (data.indexOf('L') > -1) {
      return '每月最后一天'
    }
    if (!_.isNaN(Number(data)) || data.indexOf(',') > -1) {
      return `${data}天`
    }
    if (data.indexOf('?') > -1) {
      return ''
    }
    return '天'
  },
  // cron周转中文
  weekForDesc(data) {
    if (data.indexOf('-') > -1) {
      const wArr = data.split('-')
      if (wArr.length && wArr[0] === wArr[1]) {
        return `星期${this.weekValue[wArr[0]]}`
      }
      return `星期${this.weekValue[wArr[0]]}至星期${this.weekValue[wArr[1]]}`
    }
    if (data.indexOf('/') > -1) {
      const wArr = data.split('/')
      return `从星期${this.weekValue[wArr[0]]}开始每${wArr[1]}天`
    }
    if (data.indexOf('#') > -1) {
      const wArr = data.split('#')
      return `每月第${wArr[0]}周的星期${this.weekValue[wArr[1]]}`
    }
    if (data.indexOf('L') > -1) {
      const wArr = data.split('L')
      return `每月最后一个星期${this.weekValue[wArr[0]]}`
    }
    if (!_.isNaN(Number(data)) || data.indexOf(',') > -1) {
      return `${data}天`
    }
    if (data.indexOf('?') > -1) {
      return ''
    }
    return '周'
  },
  // cron年转中文
  yearForDesc(data) {
    if (data.indexOf('/') > -1) {
      const yArr = data.split('/')
      return `从${yArr[0]}年至${yArr[1]}年`
    }
    return '年'
  },
  toDescription(val) {
    // console.log('here-here')
    // console.log(val)
    const obj = this.updateValue(val)
    // console.log(obj)
    const sDesc = this.timeForDesc('秒', obj.sVal)
    const mDesc = this.timeForDesc('分', obj.mVal)
    const hDesc = this.timeForDesc('小时', obj.hVal)
    const dDesc = this.dayForDesc(obj.dVal)
    const monthDesc = this.timeForDesc('月', obj.monthVal)
    const weekDesc = this.weekForDesc(obj.weekVal)
    const yearDesc = this.yearForDesc(obj.yearVal)
    return `每${yearDesc}${monthDesc}${weekDesc}${dDesc}${hDesc}${mDesc}${sDesc}执行一次`
  },
}

export default {
  methods: fn,
}
